<div style="border: 1px solid #ddd; border-radius: 5px; padding: 1em; background-color: white;">
  <label>Cancelled documents</label>

  @if (!dataSourceItems) {
    <div>
    </div>
  } @else {
    @if (!dataSourceItems || dataSourceItems.length === 0) {
      <div>
        <br>
          <p>This message was cancelled before any documents were created.</p>
          <button class="btn btn-primary btn-sm" (click)="showDocuments()" id="showInterchangeButton">Show interchange(s)</button>
        </div>
      } @else {
        <dx-data-grid biz-grid
          [dataSource]='dataSourceItems'
          [selection]='{ mode: "single"}'
          [bizSetColumnChooser]='false'
          [bizSetAllowColumnReordering]='false'
          [bizHideSelectedRowsComponent]='true'
          [showResetButton]='false'
          [showRefreshButton]='true'
          [bizSetGroupPanel]='false'
          [bizSetPager]="false"
          [bizSetSearchPanel]="false"
          (onRefresh)="refresh()"
          [loadPanel]='{ enabled: true }'
          [showBorders]="true">
          <ng-container>
            <dxi-column dataField="DistributionObject.Name" caption="Document Type" dataType="string" [visible]="true"></dxi-column>
            <dxi-column dataField="LatestDocumentStatus" caption="Last Status" dataType="string" cellTemplate="documentStatusTemplate" [visible]="true"></dxi-column>
            <dxi-column dataField="PartnerIn.PartnerName" caption="Partner From" dataType="string" [visible]="true"></dxi-column>
            <dxi-column dataField="PartnerOut.PartnerName" caption="Partner To" dataType="string" [visible]="true"></dxi-column>
            <dxi-column dataField="CreatedDate" caption="Created date and time" dataType="date" [visible]="true" sortOrder="desc" [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
            <dxi-column type="buttons">
              <dxi-button text="Show Document"
                [visible]="true"
                [onClick] ="showDocument">
              </dxi-button>
            </dxi-column>
          </ng-container>
          <div *dxTemplate="let document of 'documentStatusTemplate'">
            <ep-tracking-status [currentStatus]="document.data.LatestDocumentStatus.StatusTypeName"></ep-tracking-status>
          </div>
        </dx-data-grid>
      }
    }



  </div>